/* eslint-disable max-len */
import { html } from 'lit'

export const profileIcon = html`<svg
  width="25"
  height="25"
  viewBox="0 0 25 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask
    id="mask0_1_7"
    style="mask-type:alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="25"
    height="25"
  >
    <rect x="0.202118" y="0.980713" width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_1_7)">
    <path
      d="M12.2021 12.9807C11.1021 12.9807 10.1605 12.589 9.37712 11.8057C8.59378 11.0224 8.20212 10.0807 8.20212 8.98071C8.20212 7.88071 8.59378 6.93905 9.37712 6.15571C10.1605 5.37238 11.1021 4.98071 12.2021 4.98071C13.3021 4.98071 14.2438 5.37238 15.0271 6.15571C15.8105 6.93905 16.2021 7.88071 16.2021 8.98071C16.2021 10.0807 15.8105 11.0224 15.0271 11.8057C14.2438 12.589 13.3021 12.9807 12.2021 12.9807ZM4.20212 20.9807V18.1807C4.20212 17.614 4.34795 17.0932 4.63962 16.6182C4.93128 16.1432 5.31878 15.7807 5.80212 15.5307C6.83545 15.014 7.88545 14.6265 8.95212 14.3682C10.0188 14.1099 11.1021 13.9807 12.2021 13.9807C13.3021 13.9807 14.3855 14.1099 15.4521 14.3682C16.5188 14.6265 17.5688 15.014 18.6021 15.5307C19.0855 15.7807 19.473 16.1432 19.7646 16.6182C20.0563 17.0932 20.2021 17.614 20.2021 18.1807V20.9807H4.20212ZM6.20212 18.9807H18.2021V18.1807C18.2021 17.9974 18.1563 17.8307 18.0646 17.6807C17.973 17.5307 17.8521 17.414 17.7021 17.3307C16.8021 16.8807 15.8938 16.5432 14.9771 16.3182C14.0605 16.0932 13.1355 15.9807 12.2021 15.9807C11.2688 15.9807 10.3438 16.0932 9.42712 16.3182C8.51045 16.5432 7.60212 16.8807 6.70212 17.3307C6.55212 17.414 6.43128 17.5307 6.33962 17.6807C6.24795 17.8307 6.20212 17.9974 6.20212 18.1807V18.9807ZM12.2021 10.9807C12.7521 10.9807 13.223 10.7849 13.6146 10.3932C14.0063 10.0015 14.2021 9.53071 14.2021 8.98071C14.2021 8.43071 14.0063 7.95988 13.6146 7.56821C13.223 7.17655 12.7521 6.98071 12.2021 6.98071C11.6521 6.98071 11.1813 7.17655 10.7896 7.56821C10.398 7.95988 10.2021 8.43071 10.2021 8.98071C10.2021 9.53071 10.398 10.0015 10.7896 10.3932C11.1813 10.7849 11.6521 10.9807 12.2021 10.9807Z"
      fill="var(--grey)"
    />
  </g>
</svg> `
